// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_PreviewResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_PreviewResponse — POST /franchisor-channels/preview.
 *
 * `subject` is null for every sms template (email-only field, DDL-level).
 * `html` is true for an email template — its body arrives already wrapped by
 * EmailLayout, exactly as the recipient will receive it, and the console must
 * render it in a SANDBOXED iframe, never inject it into its own DOM. An sms
 * template answers html:false and stays plain text.
 * `vars_used` is the effective map (catalog samples + caller overrides), so
 * the console can show WHICH values produced the text on screen.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_PreviewResponseDados {
subject: string
body: string
html: boolean
vars_used: Record<string, string>
}

export type FranchisorChannels_PreviewResponse = ApiResponse<FranchisorChannels_PreviewResponseDados>;

registerResponseContract('FranchisorChannels_PreviewResponse', {
  subject:   { type: 'string',  required: false },
  body:      { type: 'string',  required: true },
  html:      { type: 'boolean', required: true },
  vars_used: { type: 'object',  required: true },
})
